class LazyScriptLoader {
  constructor() {
    this.scripts = [];
    this.selector = "script[data-loading=\"lazy\"][data-src]";
    this.interactionEvents = ["mouseover","keydown","touchmove","touchstart","click"];
    this.loadAfterMsIfNoInteraction = 5000;
    this.loadTimer = null;
  }

  findUniqueScripts() {
    const scripts = document.querySelectorAll(this.selector);
    const uniqueScriptIds = [];
    const uniqueScripts = [];
    scripts.forEach(script => {
      const id = script.dataset.id;
      if (id && uniqueScriptIds.includes(id)) {
        script.remove();
      }
      else {
        uniqueScriptIds.push(id);
        uniqueScripts.push(script);
        script.dataset.loading = "waiting";
      }
    });
    return uniqueScripts;
  }

  init() {
    // find all scripts
    this.scripts = this.findUniqueScripts();

    // if there are no scripts, return
    if (this.scripts.length === 0) return;
    
    this._bindStartLoading = this.startLoadingScripts.bind(this);

    // Load scripts on page load if explicitly requested
    this.scripts.forEach(script => {
      const criteria = script.dataset.criteria?.split(" ") || [];
      if(criteria.includes("load")) {
        this.loadScript(script);
      }
    });

    // load scripts on user interaction
    this.interactionEvents.forEach((event) => {
      document.addEventListener(event, this._bindStartLoading, { passive: true });
    });

    // load scripts after a timeout if no user interaction
    this.loadTimer = setTimeout(this.startLoadingScripts.bind(this), this.loadAfterMsIfNoInteraction);
  }

  startLoadingScripts() {
    clearTimeout(this.loadTimer);

    this.loadScripts();
    this.interactionEvents.forEach((event) => {
      document.removeEventListener(event, this._bindStartLoading, { capture: true });
    })
  }

  loadScripts() {
    this.scripts.forEach((script) => {
      if (script.dataset.loading === "waiting") {
        this.loadScript(script);
      }
    });
  }

  loadScript(script) {
    script.dataset.loading = "loading";
    script.src = script.dataset.src;
    script.removeAttribute("data-src");
    script.addEventListener("load", () => {
      script.dataset.loading = "loaded";
      console.log("Script loader: loaded script - " + script.src);
    });
  }
}

const loader = new LazyScriptLoader();
window.onload = loader.init.bind(loader);